const templates = [
  {
    id: "klasicni-elegantni",
    name: "Klasični Elegantni",
    description: "Elegantan dizajn s teksturom drveta i zlatnim akcentima",
    features: ["Naslovna slika", "Drvena tekstura", "Vremenska crta", "Poruka gostima"],
    preset: {
      template: 0,
      bgColor: "#F0F4F3",
      texture: "https://bucket.pozivnica.hr/ui-bucket/textures/texture4.jpg",
      headerImage: "https://bucket.pozivnica.hr/pozivnica/pexels-photo-2253870.webp",
      includeHeaderImage: true,
      highlightColor: "#b4a770",
      titleFont: "gwendolyn",
      titleColor: "#868168",
      titleFontSize: 36,
      dateFont: "montecarlo",
      dateColor: "#868168",
      dateFontSize: 20,
      dateIsBold: true,
      quoteText: "S velikom radošću pozivamo Vas da svojim prisustvom uveličate proslavu našeg vjenčanja.",
      quoteFont: "italianno",
      quoteColor: "#878268",
      quoteFontSize: 30,
      quoteIsBold: false,
      quoteIsItalic: false,
      eventTitleFont: "montecarlo",
      eventTitleColor: "#58564b",
      eventTitleFontSize: 28,
      eventTitleIsBold: true,
      eventTimeColor: "#000000",
      eventLocationColor: "#666352",
      eventLocationFontSize: 14,
      formTitleFont: "montecarlo",
      formTitleColor: "#868168",
      formSubtitleFont: "italianno",
      formSubtitleColor: "#868168",
      formSubtitleFontSize: 32,
      formSuccessFont: "montecarlo",
      formSuccessColor: "#868168",
      formSuccessFontSize: 52,
      formAddGuestFont: "montecarlo",
      formAddGuestColor: "#868168",
      messageToGuestsText: "Vaše prisustvo bit će nam najljepši dar.\nRadujemo se što ćemo ovaj poseban dan podijeliti s Vama!",
      messageToGuestsFont: "montecarlo",
      messageToGuestsFontSize: 26,
      messageToGuestsColor: "#868168",
      includeMessageToGuests: true,
      timelineWithQuote: true,
      quote: true,
      countdown: false,
      includeEmblem: false,
      includeMap: false,
      includeEmail: false,
      includePhone: true,
      events: [
        { id: 1, eventName: "Ceremonija vjenčanja", time: "14:00", location: "", icon: "235", coordinates: { lat: 0, lng: 0 } },
        { id: 2, eventName: "Svečani ručak", time: "16:00", location: "", icon: "233", coordinates: { lat: 0, lng: 0 } },
        { id: 3, eventName: "Zabava i ples", time: "20:00", location: "", icon: "224", coordinates: { lat: 0, lng: 0 } },
      ],
    },
  },
  {
    id: "romanticni-minimalisticki",
    name: "Romantični Minimalistički",
    description: "Čist dizajn bez slike, nježne ružičaste boje",
    features: ["Bez naslovne slike", "Odbrojavanje", "Vremenska crta", "Elegantan font"],
    preset: {
      template: 0,
      bgColor: "#fffafa",
      texture: "",
      headerImage: "",
      includeHeaderImage: false,
      highlightColor: "#8c6e6e",
      titleFont: "italianno",
      titleColor: "#8c6e6e",
      titleFontSize: 68,
      dateFont: "display",
      dateColor: "#8c6e6e",
      dateFontSize: 28,
      dateIsItalic: true,
      quoteText: "S veseljem Vas pozivamo da budete dio našeg dana ljubavi i sreće.",
      quoteFont: "italianno",
      quoteColor: "#8c6e6e",
      quoteFontSize: 32,
      eventTitleFont: "display",
      eventTitleColor: "#8c6e6e",
      eventTitleFontSize: 24,
      eventTimeColor: "#8c6e6e",
      eventTimeFontSize: 14,
      eventLocationColor: "#8c6e6e",
      eventLocationFontSize: 12,
      formTitleFont: "italianno",
      formTitleColor: "#8c6e6e",
      formTitleFontSize: 54,
      formSubtitleColor: "#8c6e6e",
      formSubtitleFontSize: 16,
      formSubtitleIsItalic: true,
      formSuccessFont: "italianno",
      formSuccessColor: "#8c6e6e",
      formSuccessFontSize: 64,
      formAddGuestFont: "italianno",
      formAddGuestColor: "#8c6e6e",
      countdownFont: "italianno",
      countdownColor: "#8c6e6e",
      countdownFontSize: 50,
      emblemFont: "italianno",
      emblemColor: "#8c6e6e",
      includeMessageToGuests: false,
      timelineWithQuote: true,
      quote: true,
      countdown: true,
      includeEmblem: false,
      includeMap: false,
      includeEmail: true,
      includePhone: true,
      events: [
        { id: 1, eventName: "Ceremonija vjenčanja", time: "14:00", location: "", icon: "238", coordinates: { lat: 0, lng: 0 } },
        { id: 2, eventName: "Svečani ručak", time: "16:00", location: "", icon: "241", coordinates: { lat: 0, lng: 0 } },
        { id: 3, eventName: "Zabava i ples", time: "20:00", location: "", icon: "224", coordinates: { lat: 0, lng: 0 } },
      ],
    },
  },
];

const StepChooseTemplate = ({ formData, updateFormData }) => {
  const handleTemplateSelect = (templateId) => {
    const selectedTemplate = templates.find((t) => t.id === templateId);
    if (selectedTemplate && selectedTemplate.preset) {
      updateFormData({
        ...selectedTemplate.preset,
        selectedTemplateId: templateId,
        eventName: formData.eventName,
        coupleName1: formData.coupleName1,
        coupleName2: formData.coupleName2,
        date: formData.date,
        formExpiryDate: formData.formExpiryDate,
        emblemLeftLetter: formData.emblemLeftLetter,
        emblemRightLetter: formData.emblemRightLetter,
      });
    }
  };

  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-purple-50 mb-4">
          <svg className="w-8 h-8 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
          </svg>
        </div>
        <h3 className="text-lg font-medium text-gray-900">Odaberite predložak</h3>
        <p className="text-sm text-gray-500 mt-1">Izgled koji najbolje odgovara vašem stilu</p>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {templates.map((template) => (
          <button
            key={template.id}
            type="button"
            onClick={() => handleTemplateSelect(template.id)}
            className={`relative p-4 rounded-xl border-2 text-left transition-all ${
              formData.selectedTemplateId === template.id
                ? "border-teal-500 bg-teal-50"
                : "border-gray-200 hover:border-gray-300 bg-white"
            }`}
          >
            <div className="flex items-start space-x-4">
              <div 
                className="w-24 h-32 rounded-lg flex-shrink-0 flex flex-col items-center justify-center overflow-hidden relative"
                style={{ 
                  backgroundColor: template.preset?.bgColor || "#F5F5F0",
                  backgroundImage: template.preset?.texture ? `url(${template.preset.texture})` : "none",
                  backgroundSize: "cover",
                }}
              >
                {template.preset?.includeHeaderImage && (
                  <div className="absolute top-0 left-0 right-0 h-10 bg-gradient-to-b from-gray-400/50 to-transparent" />
                )}
                <div className="text-center p-2 relative z-10">
                  <div 
                    className="w-12 h-1 rounded mx-auto mb-2" 
                    style={{ backgroundColor: template.preset?.highlightColor || "#D4AF37" }}
                  />
                  <div 
                    className="text-xs font-medium mb-1"
                    style={{ color: template.preset?.titleColor || "#000" }}
                  >
                    A & B
                  </div>
                  <div 
                    className="w-10 h-0.5 rounded mx-auto mb-3" 
                    style={{ backgroundColor: template.preset?.highlightColor || "#D4AF37" }}
                  />
                  <div className="space-y-1">
                    <div 
                      className="w-8 h-0.5 rounded mx-auto" 
                      style={{ backgroundColor: template.preset?.eventTitleColor || "#666" }}
                    />
                    <div 
                      className="w-8 h-0.5 rounded mx-auto" 
                      style={{ backgroundColor: template.preset?.eventTitleColor || "#666" }}
                    />
                    <div 
                      className="w-8 h-0.5 rounded mx-auto" 
                      style={{ backgroundColor: template.preset?.eventTitleColor || "#666" }}
                    />
                  </div>
                </div>
              </div>

              <div className="flex-1">
                <div className="flex items-center justify-between">
                  <h4 className="font-medium text-gray-900">{template.name}</h4>
                  {formData.selectedTemplateId === template.id && (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-teal-100 text-teal-800">
                      Odabrano
                    </span>
                  )}
                </div>
                <p className="text-sm text-gray-500 mt-1">{template.description}</p>
                <ul className="mt-3 space-y-1">
                  {template.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-xs text-gray-600">
                      <svg className="w-3.5 h-3.5 text-teal-500 mr-1.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {formData.selectedTemplateId === template.id && (
              <div className="absolute top-3 right-3">
                <div className="w-6 h-6 bg-teal-500 rounded-full flex items-center justify-center">
                  <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>
            )}
          </button>
        ))}
      </div>

      <div className="bg-gray-50 rounded-xl p-4 mt-6">
        <p className="text-sm text-gray-600 text-center">
          Više predložaka dolazi uskoro! 
        </p>
      </div>
    </div>
  );
};

export default StepChooseTemplate;
